import { Typography } from '@tempmee/react';
import { colors } from '@tempmee/tailwind';
import { Box, Column, Divider, Row } from '~/commonComponents';
import AcademicCapIcon from '~/images/academic-cap-icon.svg';
import OfficeBuildingIcon from '~/images/office-building-icon.svg';
import { TNullable } from '~/types/Nullable';
import { formatExperienceDates, formatGraduationDate } from '../../utils';

interface IResumePreviewProps {
  educations: IEducation[];
  experiences: IExperience[];
  professionalName: string;
  summaries: string;
}

interface IEducation {
  graduatesAt: TNullable<string>;
  institutionName: string;
}

interface IExperience {
  employerName: string;
  endsAt: TNullable<string>;
  isCurrentEmployer: boolean;
  startsAt: string;
  title: string;
}

export const ResumePreview = ({
  educations,
  experiences,
  professionalName,
  summaries,
}: IResumePreviewProps) => {
  return (
    <Box data-testid="candidate-resume">
      <Column gap={10} data-testid="about-section">
        <Typography as="span" bold size="heading_4">
          About {professionalName}:
        </Typography>
        <Typography as="span">{summaries}</Typography>
      </Column>

      <Divider height={2} marginVertical={22} width={'90%'} />

      <Column gap={14} data-testid="experience-section">
        <Typography as="span" bold size="heading_4">
          Professional Experience:
        </Typography>
        <Column gap={22}>
          {experiences?.map((it, index) => (
            <Row key={`${it.employerName}-${index}`} gap={4} data-testid="experience-item">
              <img src={OfficeBuildingIcon} alt="office building icon" width={24} height={24} />
              <Column>
                <Typography as="span" size="body_large">
                  <Typography as="span" bold size="body_large">
                    {it.employerName}
                  </Typography>{' '}
                  - {it.title}
                </Typography>
                <Typography italic color={colors.neutral[500]}>
                  {formatExperienceDates(it.startsAt, it.endsAt, it.isCurrentEmployer)}
                </Typography>
              </Column>
            </Row>
          ))}
        </Column>
      </Column>

      <Divider height={2} marginVertical={22} width={'90%'} />

      <Column gap={14} data-testid="education-section">
        <Typography as="span" bold size="heading_4">
          Highest Level of Education:
        </Typography>
        {educations?.map((it, index) => (
          <Row key={`${it.institutionName}-${index}`} gap={4} data-testid="education-item">
            <img src={AcademicCapIcon} alt="academic cap icon" width={24} height={24} />
            <Column>
              <Typography as="span" bold size="body_large">
                {it.institutionName}
              </Typography>
              <Typography italic color={colors.neutral[500]}>
                Graduation Date: {formatGraduationDate(it.graduatesAt)}
              </Typography>
            </Column>
          </Row>
        ))}
      </Column>
    </Box>
  );
};
